import { useSignOut } from '../auth/AuthProvider';
import { useAuthStore } from '../../store/useAuthStore';
import { useClientContact, useSetClientNotifications } from '../../hooks/queries/useClientDossiers';

function displayName(contact: { first_name: string | null; last_name: string | null; company_name: string | null } | null | undefined): string {
  if (!contact) return '—';
  return (
    contact.company_name ||
    [contact.first_name, contact.last_name].filter(Boolean).join(' ') ||
    '—'
  );
}

export function PortalProfilePage() {
  const signOut = useSignOut();
  const clientUser = useAuthStore((s) => s.clientUser);
  const setClientUser = useAuthStore((s) => s.setClientUser);
  const { data: contact, isLoading } = useClientContact(clientUser?.contact_id);
  const setNotifs = useSetClientNotifications();

  function handleToggleNotifs(enabled: boolean) {
    if (!clientUser) return;
    setNotifs.mutate(
      { clientUserId: clientUser.id, enabled },
      { onSuccess: () => setClientUser({ ...clientUser, notifications_enabled: enabled }) },
    );
  }

  return (
    <div className="max-w-md">
      <h1
        className="text-xl font-semibold text-cime-text-primary mb-4"
        style={{ fontFamily: 'var(--cime-font-heading)' }}
      >
        Mon profil
      </h1>
      {isLoading ? (
        <p className="text-sm text-cime-text-muted">Chargement…</p>
      ) : (
        <div className="bg-cime-surface border border-neutral-200 rounded-cime p-4 space-y-2 text-sm">
          <p>
            <span className="text-cime-text-muted">Nom : </span>
            {displayName(contact)}
          </p>
          <p>
            <span className="text-cime-text-muted">Email : </span>
            {contact?.email ?? '—'}
          </p>
          <p>
            <span className="text-cime-text-muted">Téléphone : </span>
            {contact?.phone ?? '—'}
          </p>
        </div>
      )}
      <label className="mt-4 flex items-center gap-2 text-sm text-cime-text-primary">
        <input
          type="checkbox"
          checked={clientUser?.notifications_enabled ?? true}
          onChange={(e) => handleToggleNotifs(e.target.checked)}
          disabled={setNotifs.isPending}
        />
        Recevoir les notifications par email
      </label>
      <button
        type="button"
        onClick={signOut}
        className="mt-4 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-md"
      >
        Se déconnecter
      </button>
    </div>
  );
}
